import React from 'react'
import ProjectsPage from './Projects'

const Projects = () => (
  <ProjectsPage/>
)

export default Projects
